module.exports = __webpack_public_path__ + "img/marker-red.153b03f1.svg";